import { endOfMonth, max, startOfMonth } from 'date-fns';

import { PayloadAction } from '../../../store.model';
import { SearchType } from '../../core';
import { ActionType } from '../search.action';
import { SearchState } from '../search.state';

import { Reload } from './reload.action';

export function reloadReducer(
    state: SearchState,
    action: PayloadAction<ActionType.EVAL_SEARCH__RELOAD, Reload>,
): SearchState {
    const searchType = action.payload.searchType ?? SearchType.INDIVIDUAL;

    const start = action.payload.dateRangeStart ?? startOfMonth(new Date());
    const end = action.payload.dateRangeEnd ?? endOfMonth(new Date());

    const nextRows = action.payload.user == null ? null : state.rows;

    return {
        ...state,
        pending: {
            ...state.pending,
            reload: false,
        },
        selectedSearchType: {
            value: searchType,
            initialLoad: true,
        },
        selectedUser: {
            value: action.payload.user,
            initialLoad: true,
        },
        selectedDateRange: {
            value: {
                start,
                end: max([start, end]),
            },
            initialLoad: true,
        },
        // reset when re-navigating to search while still on search (e.g. from the nav menu)
        rows: nextRows,
    };
}
